import { CommonHttpOption } from "../../base/common-http-option";
import { CoreService } from "../../base/core";
import { Injectable } from "@angular/core";
import { ServiceRoute } from "src/app/services/http/base/service-route";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class GonbadSettingService {
  constructor(private coreService: CoreService) { }

  listGonbadSetting(KeyItem: string): Observable<any> {
    return this.coreService.get(
      ServiceRoute.companySetting.listGonbadSetting + '?KeyItem=' + KeyItem,
      new CommonHttpOption().headers
    );
  }
}
